/*!

=========================================================
* Argon Dashboard React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
// reactstrap components
import { Container, Alert, Row } from 'reactstrap';
// core components
import AdminNavbar from '../components/Navbars/AdminNavbar.js';
import AdminFooter from '../components/Footers/AdminFooter.js';
import Sidebar from '../components/Sidebar/Sidebar.js';
import Header from '../components/Headers/Header';
import ProductsTable from '../views/ProductsTable';

import routes from '../routes.js';
import utils from './../utils';

class Admin extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      trends: null,
      trendsLoading: true,
      user: null,
      credentials: null,
      credentialsLoading: true,
      selectedCred: null,
      selectedAccount: null,
      license: null,
      errorMessage: null,
      redirect: false,
      checkoutFailedEvents: [],
      checkoutFailedEventsLoading: true,
      checkoutSuccessEvents: [],
      checkouts: [],
      checkoutsLoading: true,
    };
    this.shared = {
      updateUser: this.updateUser.bind(this),
      updateCredentials: this.updateCredentials.bind(this),

      updateCheckouts: this.updateCheckouts.bind(this),
      updateTrends: this.updateTrends.bind(this),

      switchToCred: this.switchToCred.bind(this),
      didSelectedCredChange: this.didSelectedCredChange.bind(this),
      getSelectedVendor: this.getSelectedVendor.bind(this),

      getDiscordInviteLink: this.getDiscordInviteLink.bind(this),
    };
  }

  // Runs once on page load
  async componentDidMount() {
    if (!this.props.license) {
      this.setState({
        redirect: '/subscribe',
      });
    } else if (this.props.license.licenseStatus !== 'active') {
      if (this.props.license.licenseType === 'lite') {
        this.setState({
          // 2/17/25: We don't sell Lite anymore, so redirect to Pro flow
          redirect: '/subscribe',
        });
      } else {
        this.setState({
          redirect: '/subscribe?action=resub',
        });
      }
    }

    this.setState({
      user: this.props.user,
      license: this.props.license,
    });

    this.updateCheckouts();
    this.updateTrends();
    const selectedAcc = await this.updateCredentials();
  }

  getDiscordInviteLink() {
    if (!this.props.license) return '';
    if (this.props.license.licenseType === 'lite') {
      return (
        <a href="https://discord.gg/WGvmUUbHqF" target="_blank">
          SnailBot Lite Discord
        </a>
      );
    } else {
      return (
        <a href="https://discord.gg/B6gdUGw5Rb" target="_blank">
          SnailBot Pro Discord
        </a>
      );
    }
  }

  async updateCheckouts() {
    const { checkouts, errorMessage } = await utils.getCheckouts();
    if (!checkouts) {
      return;
    }
    this.setState({
      checkouts,
      checkoutsLoading: false,
    });
  }

  switchToCred(cred) {
    if (!cred) return;
    utils.saveCredIdToCookie(cred.credId);
    this.setState({
      selectedCred: cred,
      selectedAccount: cred.account,
    });
  }

  async updateTrends() {
    this.setState({
      trendsLoading: true,
    });
    const { trends, errorMessage } = await utils.getTrends();
    this.setState({
      trends,
      trendsLoading: false,
      errorMessage,
    });
  }

  didSelectedCredChange(newProps, prevProps) {
    const prevCredId = prevProps.selectedCred && prevProps.selectedCred.credId;
    const newCredId = newProps.selectedCred && newProps.selectedCred.credId;
    return prevCredId !== newCredId;
  }

  async updateUser() {
    const { user, license, errorMessage } = await utils.getUser();
    this.setState({ user, license });
  }

  getSelectedVendor() {
    if (!this.state.selectedCred) return;
    return this.state.selectedCred.vendor;
  }

  async updateCredentials(input) {
    let vaIdToSelectAfter = null;
    if (input && input.vaIdToSelectAfter)
      vaIdToSelectAfter = input.vaIdToSelectAfter;

    const { credentials, errorMessage } = await utils.getCredentials();
    if (!credentials) {
      this.setState({
        errorMessage: errorMessage || 'Something went wrong.',
      });
      return;
    }

    let credToSelect = null;
    let accountToSelect = null;

    if (vaIdToSelectAfter) {
      const matchingCredential = credentials.find(
        (c) => c.account && c.account.vendorAccountId === vaIdToSelectAfter
      );
      if (matchingCredential) {
        credToSelect = matchingCredential;
      }
    }

    if (!credToSelect && this.state.selectedAccount) {
      const matchingCredential = credentials.find(
        (c) =>
          c.account &&
          c.account.vendorAccountId ===
            this.state.selectedAccount.vendorAccountId
      );
      if (matchingCredential) {
        credToSelect = matchingCredential;
      }
    }

    let credIdToLookFor = null;
    if (this.state.selectedCred) {
      credIdToLookFor = this.state.selectedCred.credId;
    } else {
      credIdToLookFor = utils.getCredIdFromCookie();
    }

    if (!credToSelect && credIdToLookFor) {
      const matchingCredential = credentials.find(
        (c) => c.credId === credIdToLookFor
      );
      if (matchingCredential) {
        credToSelect = matchingCredential;
      }
    }

    // Default case: just find first slot with an account, or fallback to first slot
    if (!credToSelect && credentials.length > 0) {
      credToSelect = credentials.find((c) => c.account) || credentials[0];
    }

    if (credToSelect) {
      accountToSelect = credToSelect.account;
      utils.saveCredIdToCookie(credToSelect.credId);
    }

    this.setState({
      credentials,
      selectedCred: credToSelect,
      selectedAccount: accountToSelect,
      credentialsLoading: false,
    });

    return accountToSelect;
  }

  // TODO: remove?
  // async updateUserEvents() {
  //   const { events, errorMessage } = await utils.getEvents();
  //   if (!events) {
  //     return;
  //   }
  //
  //   const checkoutFailedEvents = [];
  //
  //   for (const event of events) {
  //     const { eventName, eventTime, eventData } = event;
  //     if (eventName === 'CheckoutFailed' && eventData) {
  //       const { alert } = eventData;
  //       if (alert) {
  //         if (alert.vendorProduct) {
  //           const { vendor, vendorProductId, link, name } = alert.vendorProduct;
  //           alert.name = name;
  //           alert.id = vendorProductId;
  //           alert.vendor = vendor;
  //           alert.link = link;
  //           alert.isCombo = alert.isNeweggCombo;
  //         }
  //         event.prettyEventName = 'ATC/Checkout Failure';
  //         checkoutFailedEvents.push(event);
  //       }
  //     } else if (eventName === 'CheckoutSuccess') {
  //     }
  //   }
  //   this.setState({
  //     checkoutFailedEvents,
  //     checkoutFailedEventsLoading: false,
  //   });
  // }
  //

  // Runs on change, does not run on mount
  componentDidUpdate(e) {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    this.refs.mainContent.scrollTop = 0;
  }

  getRoutes = (routes, parentProps) => {
    return routes.map((prop, key) => {
      if (prop.layout === '') {
        return (
          <Route
            path={prop.layout + prop.path}
            // component={prop.component}
            render={(props) => (
              <prop.component
                {...props}
                {...parentProps}
                {...this.state}
                {...this.shared}
              />
            )}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };

  getBrandText = (path) => {
    for (let i = 0; i < routes.length; i++) {
      if (
        this.props.location.pathname.indexOf(
          routes[i].layout + routes[i].path
        ) !== -1
      ) {
        return routes[i].name;
      }
    }
    return 'Brand';
  };

  renderRedirect = () => {
    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} />;
    }
  };

  render() {
    return (
      <>
        {this.renderRedirect()}
        <Sidebar
          {...this.props}
          {...this.state}
          {...this.shared}
          routes={routes}
          logo={{
            innerLink: '/index',
            imgSrc: `${process.env.PUBLIC_URL}/images/snailbotlogo_128.png`,
            imgAlt: '...',
          }}
        />

        <div className="main-content" ref="mainContent">
          <AdminNavbar
            {...this.props}
            brandText={this.getBrandText(this.props.location.pathname)}
          />

          <Header {...this.props} {...this.state} {...this.shared} />

          <Switch>
            {this.getRoutes(routes, this.props)}
            {/*<ProductsTable {...this.props} {...this.state} {...this.shared} />*/}
            <Redirect from="*" to="/home" />
          </Switch>
          <Container fluid>
            <AdminFooter />
          </Container>
        </div>
      </>
    );
  }
}

export default Admin;
